import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DASHBOARDS_CONSTANTS } from "src/constants/dashboardConstants";
import { dashboardLocales } from "src/locales/dashboardLocales";
import { JobApplicationDetail } from "src/models/dashboard.models";
import API_SERVICES from "src/services";

import { CCard } from "@coreui/react";

import CustomPagination from "../CustomPagination/CustomPagination";

const JobApplication: React.FC = () => {
  const [jobApplications, setJobApplications] =
    useState<JobApplicationDetail[]>();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [paginationSize, setPaginationSize] = useState(10);

  useEffect(() => {
    const fetchJobDirection = async () => {
      const payload = {
        page: page,
        limit: paginationSize,
        sort: DASHBOARDS_CONSTANTS.SORT_DESC,
        type: DASHBOARDS_CONSTANTS.TYPE,
      };
      const data = await API_SERVICES.DASHBOARD.GET_JOB_REDIRECTION(payload);
      if (data?.items) {
        setJobApplications(data.items);
        setTotalPages(data.page_count);
      }
    };

    fetchJobDirection();
  }, [page, paginationSize]);

  const handlePaginationSize = (paginationSize: number) => {
    setPaginationSize(paginationSize);
    setPage(DASHBOARDS_CONSTANTS.SET_PAGE);
  };

  const handlePagination = (page: number) => {
    setPage(page);
  };
  const handleViewDetails = (params: string, tab: number = 0) => {
    navigate(`${DASHBOARDS_CONSTANTS.JOB_DETAIL_VIEW}${params}?tab=${tab}`);
  };

  const navigate = useNavigate();

  return (
    <>
      <div className="dd-job-data dd-scrollbar">
        <h4 className="fw-bold pt-2">{dashboardLocales.jobs.JobApplication}</h4>
        {jobApplications && jobApplications.length > 0 ? (
          <ul className="list-group w-100">
            {jobApplications?.map(jobApplication => (
              <li key={jobApplication.uuid} className="list-group-item">
                <CCard>
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="m-0 mt-2 text-body-secondary">
                        {jobApplication.notification.message.content}
                      </p>
                    </div>
                    <div>
                      <button
                        onClick={() =>
                          handleViewDetails(
                            jobApplication?.notification?.meta_data?.uuid,
                            DASHBOARDS_CONSTANTS.VIEW_INITIAL_TAB
                          )
                        }
                        className="btn btn-primary btn  dd-login-button px-4"
                      >
                        {dashboardLocales.view}
                      </button>
                    </div>
                  </div>
                </CCard>
              </li>
            ))}
          </ul>
        ) : (
          <h6 className="text-center">
            {dashboardLocales.noApplicationsToDisplay}
          </h6>
        )}
      </div>
      {jobApplications && jobApplications.length > 0 && (
        <CustomPagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={handlePagination}
          onPageSizeChange={handlePaginationSize}
        />
      )}
    </>
  );
};

export default JobApplication;
